/**
 * Create Cart context for custom hook
 */

import { createContext } from 'react'

const CartContext = createContext({
  cartIds: {},
  checkout: () => {},
  createCart: () => {},
  createIsolateCart: () => {},
  fetchCart: () => {},
  fetchIsolateCart: () => {},
  mergeCart: () => {},
  reset: () => {},
  updateCart: () => {},
  updateIsolateCart: () => {},
})

export default CartContext
